export default class {
	uuid
	lat
	lng
	country
	county
	city
	address
	uid
	data
	formatted_address

	constructor( { uuid, lat, lng, country, county, city, address, formatted_address, uid, data } = {} ) {
		this.uuid = uuid
		this.lat = lat
		this.lng = lng
		this.country = country
		this.county = county
		this.city = city
		this.address = address
		this.formatted_address = formatted_address
		this.uid = uid
		this.data = data
	}

	smallest_division() {
		if (this.city.name) {
			return this.city.name
		}
		if (this.county.name) {
			return this.county.name
		}
		if (this.country.name) {
			return this.country.name
		}
	}

	// get formatted_address(){
	//
	// 	return [this.city?.name, this.county?.name, this.country?.name].filter(Boolean).join(', ')
	// }
}